// extracted by mini-css-extract-plugin
export default {"homepage":"Welcome_homepage__oaBIH","title":"Welcome_title__juzyd"};